import { Routes } from '@angular/router';

import { AuthGuard } from '@app/shared/_guards/auth.guard';
import { RegisterGuard } from './shared/_guards/register.guard';

import { GeneralLayoutComponent } from '@app/shared/_layouts/general-layout/general-layout.component';
import { IsLoggedIn } from '@app/shared/_helpers/islogged';

export const appRoutes: Routes = [
  {
    path: '',
    component: GeneralLayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', title: 'Dashboard', loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.dashboardRoutes) },
      { path: 'analytics', title: 'Analytics', loadChildren: () => import('./features/analytics/analytics.routes').then(m => m.analyticsRoutes) },
      { path: 'suppressions', title: 'Suppressions', loadChildren: () => import('./features/suppressions/suppressions.routes').then(m => m.suppressionsRoutes) },
      { path: 'subaccounts', title: ' Sub-accounts', loadChildren: () => import('./features/subaccounts/subaccounts.routes').then(m => m.subaccountsRoutes) },
      { path: 'emailvalidator', title: 'Email Validator', loadChildren: () => import('./features/emailvalidator/emailvalidator.routes').then(m => m.emailValidatorRoutes) },
      { path: 'addons', title: 'Addons', loadChildren: () => import('./features/addons/addons.routes').then(m => m.addonsRoutes) },
      { path: 'myaccount', title: 'My Account', loadChildren: () => import('./features/myaccount/myaccount.routes').then(m => m.myAccountRoutes) },
      { path: 'settings', title: 'Settings', loadChildren: () => import('./features/settings/settings.routes').then(m => m.settingsRoutes) },
      { path: 'getting-started', title: 'Getting Started', loadChildren: () => import('./features/getting-started/getting-started.routes').then(m => m.gettingStartedRoutes) }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'forgot-password', title: 'Forgot Password',
    loadChildren: () => import('./features/forgot-password/forgot-password.routes').then(m => m.forgotPasswordRoutes),
    resolve: [IsLoggedIn]
  },
  { path: 'register', title: 'Register', canActivate: [RegisterGuard], component: GeneralLayoutComponent },
  { path: 'direct-login', title: 'Direct Login', loadChildren: () => import('./features/direct-login/direct-login.routes').then(m => m.directLoginRoutes), resolve: [IsLoggedIn] },
  { path: 'complete-profile', title: 'Complete Profile', loadChildren: () => import('./features/profile-completion/profile-completion.routes').then(m => m.profileCompletionRoutes) },
  { path: 'server-error', title: 'Session Interrupted', loadChildren: () => import('./features/server-error/server-error.routes').then(m => m.serverErrorRoutes) },
  { path: '**', redirectTo: 'dashboard' }
];
